import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "text-xs font-medium text-gray-700" }

import { computed, ref, watch } from "vue";
import SidebarNavigation from "./sidebarNavigation.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'sidebarTextList',
  props: {
    filter: { default: () => ({values: {}}) },
    activeValue: { default: () => [] },
    singleSelect: { type: Boolean, default: false }
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const itemKeys = computed(() => Object.keys(props.filter.values));
const itemRefs = ref<HTMLElement[]>([]);
const scrollContainer = ref<HTMLElement | null>(null);
const manualIndex = ref(0);

const currentIndex = computed({
  get: () => manualIndex.value,
  set: (val) => {
    manualIndex.value = val;
    scrollToIndex(val);
  }
});

const scrollToIndex = (index: number) => {
  const el = itemRefs.value[index];
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }
};

const onScroll = () => {
  if (!scrollContainer.value) return;
  const container = scrollContainer.value;
  const containerCenter = container.scrollLeft + container.clientWidth / 2;

  let closestIndex = 0;
  let minDistance = Infinity;

  itemRefs.value.forEach((el, index) => {
    if (!el) return;
    const elCenter = el.offsetLeft + el.clientWidth / 2;
    const distance = Math.abs(elCenter - containerCenter);
    if (distance < minDistance) {
      minDistance = distance;
      closestIndex = index;
    }
  });

  manualIndex.value = closestIndex;
};

watch(() => props.activeValue, (newVal) => {
  const val = Array.isArray(newVal) ? newVal[0] : newVal;
  const idx = itemKeys.value.indexOf(val?.toString() || "");
  if (idx >= 0) {
    manualIndex.value = idx;
  }
}, { immediate: true });

const toggleValue = (val: string) => {
  if (props.singleSelect) {
    emit("update", val);
  } else {
    let newValue = Array.isArray(props.activeValue) ? [...props.activeValue] : [];
    const index = newValue.indexOf(val);
    if (index > -1) {
      newValue.splice(index, 1);
    } else {
      newValue.push(val);
    }
    emit("update", newValue);
  }
};

const isActive = (val: string) => {
  return (Array.isArray(props.activeValue) && props.activeValue.includes(val)) || props.activeValue === val || (val == "" && !props.activeValue.includes(val));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "scrollContainer",
      ref: scrollContainer,
      class: "flex gap-8 pb-4 px-2 overflow-x-auto no-scrollbar scroll-smooth",
      onScroll: onScroll
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filter.values, (label, val, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: val,
          ref_for: true,
          ref: el => { if (el) itemRefs.value[index] = el as any },
          class: "flex flex-col items-center cursor-pointer min-w-fit justify-end",
          onClick: ($event: any) => (toggleValue(val.toString()))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["px-4 py-2 flex items-center justify-center mb-2 transition-all duration-300 overflow-hidden", isActive(val.toString()) ? 'border-b border-brand-main' : ''])
          }, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(label), 1)
          ], 2)
        ], 8, _hoisted_2))
      }), 128))
    ], 544),
    _createVNode(SidebarNavigation, {
      total: itemKeys.value.length,
      modelValue: currentIndex.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentIndex).value = $event)),
      container: scrollContainer.value
    }, null, 8, ["total", "modelValue", "container"])
  ]))
}
}

})